<template>
	<div class="mc-console" id="mc-console">
		<div class="mc-console-left">
			<button class="btn btn-info mc-console-button"
					:class="isSupportEnabled ? '' : 'disabled'"
					:disabled="!isSupportEnabled"
					id="mc-console-button-support"
					title="Hilfe von MathCoach anfordern"
					@click="onShowSupport">
				<i class="fa fa-question fa-lg"></i>
			</button>
			<button class="btn btn-danger mc-console-button"
					:class="(isClearEnabled && isSubmitEnabled) ? '' : 'disabled'"
					:disabled="!(isClearEnabled && isSubmitEnabled)"
					id="mc-console-button-clear"
					title="Textfeld leeren"
					@click="onClearConsole">
				<i class="fa fa-times fa-lg"></i>
			</button>
		</div>
		<div class="mc-console-middle">
            <textarea :value="consoleInput"
					  :placeholder="placeHolder"
					  @input="updateConsoleInput"
					  :disabled="!isSubmitEnabled"
					  :class="inputFieldClasses"
					  :title="mcConsoleValidation.message"
					  id="mc-console-textarea"
					  rows="3"
					  class="mc-console-text form-control"/>
		</div>
		<div class="mc-console-right">
			<button class="btn btn-primary mc-console-button-submit"
					id="mc-console-button-submit"
					title="Antwort an MathCoach senden"
					:disabled="!(isSubmitEnabled && mcConsoleValidation.isSyntacticallyValid)"
					:class="isSubmitEnabled ? '' : 'disabled'"
					@click="onSubmit">
				<i class="fa fa-paper-plane fa-2x"></i>
			</button>
		</div>
	</div>
</template>

<script>
	import Logger from "../../shared/logger";
	const LOGGER = new Logger(__filename);

	import { SET_CONSOLE_INPUT } from "./store";

	export default {
		computed: {
			inputFieldClasses(){
				let classes = [];
				if(!this.isSubmitEnabled) classes.push("disabled");
				if(!this.mcConsoleValidation.isSyntacticallyValid) classes.push("is-invalid");
				return classes.join(" ");
			},
			mcConsoleValidation(){
				return this.$store.getters.mcConsoleValidation;
			},
			placeHolder() {
				return this.$store.state.console.placeHolder;
			},
			consoleInput() {
				return this.$store.state.console.consoleInput;
			},
			isClearEnabled() {
				const layout = this.$store.state.layout;
				if (layout) {
					return layout.buttons.indexOf("clear") >= 0;
				}
				return false;
			},
			isSupportEnabled() {
				const layout = this.$store.state.layout;
				if (layout) {
					return layout.buttons.indexOf("help") >= 0;
				}
				return false;
			},
			isSubmitEnabled() {
				const layout = this.$store.state.layout;
				if (layout) {
					return layout.buttons.indexOf("submit") >= 0;
				}
				return false;
			}
		},
		methods: {
			updateConsoleInput(e) {
				let consoleInput = e.target.value;
				this.$store.commit(SET_CONSOLE_INPUT, consoleInput);
			},
			async onShowSupport() {
				LOGGER.log("onShowSupport");
				await this.$store.dispatch("support");
			},
			async onClearConsole() {
				LOGGER.log("onClearConsole");
				this.$store.commit(SET_CONSOLE_INPUT, "");
			},
			async onSubmit() {
				LOGGER.log("onSubmit");
				await this.$store.dispatch("sendCmd");
			}
		}
	};
</script>


<style scoped>
	.mc-console {
		position: absolute;
		width: 100%;
		max-width: 600px;
		height: 100px;
		background-color: white;
	}

	.mc-console-left {
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 50px;
	}
	.mc-console-middle {
		margin: 2px 2px 2px 2px;
		position: absolute;
		left: 50px;
		top: 0;
		bottom: 0;
		right: 100px;
	}
	.mc-console-right {
		position: absolute;
		width: 100px;
		top: 0;
		bottom: 0;
		right: 0;
	}

	.mc-console-text {
		position: absolute;
		resize: none;
		/*
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		  */
		height: 100%;
		width: 100%;
	}

	.mc-console-button {
		width: 46px;
		height: 46px;
		margin: 2px 2px 2px 2px;
	}
	.mc-console-button-submit {
		width: 96px;
		height: 96px;
		margin: 2px 2px 2px 2px;
	}

	button.disabled {
		cursor: not-allowed;
		opacity: 0.3;
	}
</style>